function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/web.dom-collections.iterator.js";
import i18next from "i18next";
import { lazy, Suspense } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import AnimatedSpinnerIcon from "../../../Styled/AnimatedSpinnerIcon";
import RaiseToUserErrorBoundary from "../../Errors/RaiseToUserErrorBoundary";
import { Frame, Main } from "../ToolModal";
import { jsx as _jsx } from "react/jsx-runtime";
const ItemSearchTool = /*#__PURE__*/lazy(() => import("./ItemSearchTool"));

/**
 * Lazily loads the item search tool while showing a the search window and an animated spinner.
 */
const LazyItemSearchTool = props => {
  const {
    viewState,
    item
  } = props;
  const itemName = CatalogMemberMixin.isMixedInto(item) ? item.name : "Item";
  const [t] = useTranslation();
  return /*#__PURE__*/_jsx(Suspense, {
    fallback: /*#__PURE__*/_jsx(Frame, {
      viewState: viewState,
      title: t("itemSearchTool.title", {
        itemName
      }),
      children: /*#__PURE__*/_jsx(Wrapper, {
        children: /*#__PURE__*/_jsx(AnimatedSpinnerIcon, {
          light: true,
          styledWidth: "25px",
          styledHeight: "25px"
        })
      })
    }),
    children: /*#__PURE__*/_jsx(RaiseToUserErrorBoundary, {
      viewState: viewState,
      terriaErrorOptions: {
        title: i18next.t("itemSearchTool.toolLoadError")
      },
      children: /*#__PURE__*/_jsx(ItemSearchTool, _objectSpread({}, props))
    })
  });
};
const Wrapper = styled(Main).withConfig({
  displayName: "LazyItemSearchTool__Wrapper",
  componentId: "sc-1xmb27i-0"
})(["align-items:center;justify-content:center;"]);
export default LazyItemSearchTool;